<div class="cl-container">

  <!-- Page Header -->
  <div class="cl-header">
    <h2 class="cl-header-title">WhatsApp Conversations</h2>
  </div>

  <!-- Filter Bar -->
  <div class="cl-action-bar">

    <!-- Search -->
    <div class="cl-search-wrap">
      <svg class="cl-search-icon" xmlns="http://www.w3.org/2000/svg" width="15" height="15"
           fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      <input
        type="text"
        [formControl]="searchControl"
        placeholder="Search by phone number..."
        class="cl-input cl-input-search "
        inputmode="numeric"
        (keypress)="onSearchKeyPress($event)"
        (input)="onSearchInput($event)"
      />
    </div>

    <div class="cl-divider"></div>

    <!-- Date From -->
    <div class="col-md-3 col-sm-6 mt-custom">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Range From</mat-label>
        <input
          matInput
          [matDatepicker]="dateFromPicker"
          [(ngModel)]="fromDate"
          name="fromDate"
          [max]="toDate"
          readonly />
        <mat-datepicker-toggle matIconSuffix [for]="dateFromPicker"></mat-datepicker-toggle>
        <mat-datepicker #dateFromPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <!-- Date To -->
    <div class="col-md-3 col-sm-6 mt-custom">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Range To</mat-label>
        <input
          matInput
          [matDatepicker]="dateToPicker"
          [(ngModel)]="toDate"
          name="toDate"
          [min]="fromDate"
          readonly/>
        <mat-datepicker-toggle matIconSuffix [for]="dateToPicker"></mat-datepicker-toggle>
        <mat-datepicker #dateToPicker></mat-datepicker>
      </mat-form-field>
    </div>

  </div>

  <!-- Filter Actions Row -->
  <div class="cl-action-row">
    <div *ngIf="dateError" class="cl-date-error">{{ dateError }}</div>

    <button class="cl-btn-apply" (click)="applyFilters()">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="33"
           fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2a1 1 0 01-.293.707L13 13.414V19a1 1 0 01-.553.894l-4 2A1 1 0 017 21v-7.586L3.293 6.707A1 1 0 013 6V4z"/>
      </svg>
      Apply
    </button>

    <button class="cl-btn-clear" (click)="onClear()">
      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="33"
           fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
      </svg>
      Clear
    </button>
  </div>

  <!-- Table -->
  <div class="cl-table-wrap">
    <table class="cl-table">
      <thead>
        <tr>
          <th class="cl-th cl-th-num">#</th>
          <th class="cl-th">Phone Number</th>
          <th class="cl-th cl-th-msgs">Messages</th>
          <th class="cl-th cl-th-action">Action</th>
        </tr>
      </thead>
      <tbody>

        <!-- Loading skeleton -->
        <ng-container *ngIf="isLoading">
          <tr class="cl-skeleton-row" *ngFor="let n of [1,2,3,4,5,6,7,8]">
            <td class="cl-td cl-td-num"><div class="cl-sk cl-sk-xs"></div></td>
            <td class="cl-td"><div class="cl-sk" style="width:160px"></div></td>
            <td class="cl-td cl-td-msgs"><div class="cl-sk cl-sk-md" style="margin:auto"></div></td>
            <td class="cl-td cl-td-action"><div class="cl-sk cl-sk-sm" style="margin:auto"></div></td>
          </tr>
        </ng-container>

        <!-- Empty -->
        <tr *ngIf="!isLoading && sessions.length === 0" >
          <td colspan="4" class="cl-td cl-td-empty">
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 24 24" stroke="#cbd5e1" stroke-width="1.5" style="display:block;margin:0 auto 12px">
              <path stroke-linecap="round" stroke-linejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"/>
            </svg>
            No sessions found.
          </td>
        </tr>

        <!-- Data rows -->
        <ng-container *ngIf="!isLoading">
          <tr
            *ngFor="let session of sessions; let i = index; trackBy: trackByIndex"
            class="cl-tr"
            [class.row-odd]="i % 2 !== 0"
          >
            <td class="cl-td cl-td-num">{{ session?.sr }}</td>

            <td class="cl-td cl-td-phone">
              <div class="cl-phone-cell">
                <div class="cl-phone-dot"></div>
                <span class="cl-phone-num">{{ session?.phoneNumber }}</span>
              </div>
            </td>

            <td class="cl-td cl-td-msgs">
              <span class="cl-msg-badge">{{ session?.messageCount }}</span>
            </td>

            <td class="cl-td cl-td-action">
              <button class="cl-icon-btn" title="View Conversation" (click)="openConversation(session.phoneNumber)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                     fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
                </svg>
              </button>
            </td>
          </tr>
        </ng-container>

      </tbody>
    </table>
  </div>

  <!-- Pagination -->
  <div class="cl-pagination">
    <span class="cl-page-summary">
      Showing {{ (currentPage * pageSize) + 1 }}–{{ pageEnd }} of {{ totalElements | number }}
    </span>
    <div class="cl-page-nav">
      <button class="cl-pg-btn" [disabled]="currentPage === 0" (click)="goToPrev()">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7"/>
        </svg>
        Prev
      </button>
      <span class="cl-page-pill">{{ displayPage }} / {{ totalPages }}</span>
      <button class="cl-pg-btn cl-pg-next" [disabled]="currentPage >= totalPages - 1" (click)="goToNext()">
        Next
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5l7 7-7 7"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Conversation Modal -->
  <div class="cl-overlay" *ngIf="showModal">
    <div class="cl-session-modal">

      <div class="cl-session-header">
        <div class="cl-header-icon-modal">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </div>
        <div class="cl-session-title">
          <div class="cl-session-label">WhatsApp Conversation</div>
          <div class="cl-session-id-full">{{ selectedPhone }}</div>
        </div>
        <div class="cl-session-meta">{{ messages.length }} Messages</div>
        <button class="cl-close-btn" (click)="closeModal()">×</button>
      </div>

      <div class="cl-conversation">

        <div *ngIf="isModalLoading" class="cl-modal-loading">
          <div class="cl-spinner"></div>
          <span>Loading conversation...</span>
        </div>

        <div *ngIf="!isModalLoading && messages.length === 0" class="cl-no-messages">
          No conversation history found.
        </div>

        <ng-container *ngIf="!isModalLoading">
          <ng-container *ngFor="let msg of messages; trackBy: trackByIndex">

            <div *ngIf="isSessionMarker(msg)" class="cl-session-marker">
              <span class="cl-session-badge">{{ msg.sessionStatus }}</span>
            </div>

            <div
              *ngIf="msg.message"
              class="cl-bubble-wrap"
              [class.cl-inbound]="msg.direction === 'INBOUND'"
              [class.cl-outbound]="msg.direction === 'OUTBOUND'"
            >
              <div class="cl-avatar"
                   [class.cl-avatar-in]="msg.direction === 'INBOUND'"
                   [class.cl-avatar-out]="msg.direction === 'OUTBOUND'">
                {{ msg.direction === 'INBOUND' ? 'U' : 'Bot' }}
              </div>
              <div class="cl-bubble"
                   [class.cl-bubble-in]="msg.direction === 'INBOUND'"
                   [class.cl-bubble-out]="msg.direction === 'OUTBOUND'">
                <div class="cl-bubble-text">{{ msg.message }}</div>
                <div class="cl-bubble-footer">
                  <span class="cl-bubble-time">{{ msg.dateTime | date:'dd/MM HH:mm' }}</span>
                  <span *ngIf="msg.messageType" class="cl-type-badge">{{ msg.messageType }}</span>
                  <span *ngIf="msg.messageStep" class="cl-step-badge">{{ msg.messageStep }}</span>
                </div>
              </div>
            </div>

          </ng-container>
        </ng-container>

      </div>
    </div>
  </div>

</div>